import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from '../card/card.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { WarpPreviewComponent } from 'src/app/features/warp-preview/warp-preview.component';
import { Router } from '@angular/router';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { QuestionnaireStatusComponent } from '../../../table-grid/features/questionnaires-list-page/components/questionnaire-status/questionnaire-status.component';
import { GlobalStore } from 'src/app/store/global-store';
import { QuestionnaireStatusToUserComponent } from '../../../table-grid/features/questionnaires-list-page/components/questionnaire-status-to-user/questionnaire-status-to-user.component';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
@Component({
    selector: 'que-templates-cards',
    imports: [CommonModule, CardComponent, WarpPreviewComponent, ReactiveFormsModule, TranslateDirective, TranslatePipe, QuestionnaireStatusComponent, QuestionnaireStatusToUserComponent, QueDatePipe],
    templateUrl: './templates-cards.component.html',
    styleUrls: ['./templates-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplatesCardsComponent {
  #questionnairesGridStore = inject(QuestionnairesGridStore);
  #questionnaireApiService = inject(QuestionnaireApiService);
  #router = inject(Router)
  templates$ = toSignal(this.#questionnairesGridStore.questionnaires$);
  loadingExtra$ = this.#questionnairesGridStore.loadingExtraSig$;
  isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
  isDisplayUser$ = toSignal(inject(ManipulationsToolbarStore).isDisplayUser$);
  chooseTemplate(id: number) {
    this.#questionnaireApiService.duplicateQuestionnaire(id).subscribe(
      newId =>
        this.#router.navigate(['create', newId])
    );
  }

}
